module.exports = __webpack_public_path__ + "img/user-management.df75bacc.svg";